import PropTypes from "prop-types";
import React from "react";
import { DefaultToast } from "react-toast-notifications";

const MyCustomToast = props => {
  const { content, children, onClick, idreport } = props;
  return (
    <DefaultToast {...props}>
      <div
        id={`${idreport}`}
        dangerouslySetInnerHTML={{
          __html: children,
        }}
        style={{ cursor: onClick && "pointer", whiteSpace: "pre-line" }}
        onClick={() => {
          onClick && onClick(idreport);
        }}
      ></div>
    </DefaultToast>
  );
};

MyCustomToast.propTypes = {
  content: PropTypes.any,
  children: PropTypes.any,
  onClick: PropTypes.any,
  idreport: PropTypes.any,
};

export default MyCustomToast;
